import { render } from "./ContentCardGameProbabilities.vue?vue&type=template&id=f443b44a"
import script from "./ContentCardGameProbabilities.vue?vue&type=script&lang=js"
export * from "./ContentCardGameProbabilities.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/help/ContentCardGameProbabilities.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f443b44a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f443b44a', __exports__)) {
    api.reload('f443b44a', __exports__)
  }
  
  module.hot.accept("./ContentCardGameProbabilities.vue?vue&type=template&id=f443b44a", () => {
    api.rerender('f443b44a', render)
  })

}


export default __exports__